import { ApolloClient, gql, NormalizedCacheObject, useQuery } from "@apollo/client";
import { Query, QueryGetVideoScoringStatesArgs } from "../types/generated/graphql";

export const useGetAllVideos = (client: ApolloClient<NormalizedCacheObject>, limit: number = 100) => {
  type T = Pick<Query, 'getAllVideos'>;
  const ret = useQuery<T>(QUERY_GET_ALL_VIDEOS, {
    client,
    variables: { limit },
    fetchPolicy: "network-only", // Always fetch from the server
  });

  return ret;
}

/**
 * Per-video scoring flags (has agent score / has feedback). The admin
 * Videos tab consumes these to filter by scored state. Skip when the
 * videoIds list is empty so we don't fire a no-op query on first
 * render.
 */
const QUERY_GET_VIDEO_SCORING_STATES = gql`
  query getVideoScoringStates($videoIds: [String!]!) {
    getVideoScoringStates(videoIds: $videoIds) {
      videoId
      hasAgentScore
      hasFeedback
      inheritedFromChannel
    }
  }
`;

export const useGetVideoScoringStates = (
  client: ApolloClient<NormalizedCacheObject>,
  videoIds: string[],
) => {
  type T = Pick<Query, 'getVideoScoringStates'>;
  return useQuery<T, QueryGetVideoScoringStatesArgs>(QUERY_GET_VIDEO_SCORING_STATES, {
    client,
    variables: { videoIds },
    fetchPolicy: 'cache-and-network',
    skip: videoIds.length === 0,
  });
};

const QUERY_GET_ALL_VIDEOS = gql`
  query getAllVideos($limit: Int) {
    getAllVideos(limit: $limit) {
      id
      title
      description
      duration
      published
      view_count
      snapshot_date
      author {
        id
        name
        thumbnails {
          url
          height
          width
        }
      }
      thumbnails {
        url
        height
        width
      }
      feedback {
        dontRecommendChannel {
          token
          undoToken
        }
        notInterested {
          token
          undoToken
        }
      }
    }
  }
`;